export default __webpack_public_path__ + "static/media/a037-2.bd179ba7.svg";